import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

type Tone = "success" | "warning" | "danger" | "brand" | "muted";

const TONE_CLASS: Record<Tone, string> = {
  success: "bg-success-soft text-success ring-success/25",
  warning: "bg-warning-soft text-warning ring-warning/25",
  danger: "bg-danger-soft text-danger ring-danger/25",
  brand: "bg-brand-soft text-brand-strong ring-brand/20",
  muted: "bg-surface text-muted ring-line",
};

/** Small rounded status/attribute pill — mirrors the admin panel's shareholder
 * KYC-status and index badges, using this app's own tone tokens. */
export function Pill({ tone = "muted", children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset",
        TONE_CLASS[tone],
      )}
    >
      {children}
    </span>
  );
}
